export const getPrice = (price: number) => {
    return price / 100;
};
